import { render, staticRenderFns } from "./DatabaseLookups.vue?vue&type=template&id=64f97dde&scoped=true&"
import script from "./DatabaseLookups.vue?vue&type=script&lang=js&"
export * from "./DatabaseLookups.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseLookups.vue?vue&type=style&index=0&id=64f97dde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f97dde",
  null
  
)

export default component.exports